import 'scripts/utils/requestIdleCallback.js';

class RecaptchaEnterprise {
  isLoaded
  siteKey
  recaptchaReady
  pendingActions

  constructor() {
    this.isLoaded = false
    this.siteKey = null
    this.recaptchaReady = false
    this.pendingActions = []
  }

  async initialize() {
    if (this.isLoaded) {
      return Promise.resolve()
    }

    this.siteKey = window.GOOGLE_SITE_KEY

    return new Promise((resolve, reject) => {
      try {
        const script = document.createElement("script")
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`
        script.async = true
        script.defer = true

        script.onload = () => {
          window.grecaptcha.enterprise.ready(() => {
            this.isLoaded = true
            this.recaptchaReady = true

            this.processPendingActions()

            resolve()
          })
        }

        script.onerror = () => {
          reject(new Error("Failed to load reCAPTCHA script"))
        }

        document.head.appendChild(script)
      } catch (error) {
        reject(error)
      }
    })
  }

  async executeRecaptcha(action) {
    if (!this.isLoaded || !this.recaptchaReady) {
      return new Promise((resolve, reject) => {
        this.pendingActions.push({ action, resolve, reject })
      })
    }
    try {
      const token = await window.grecaptcha.enterprise.execute(this.siteKey, {
        action: action,
      })

      return {
        token,
        action,
        timestamp: new Date().toISOString(),
      }
    } catch (error) {
      throw new Error("reCAPTCHA execution failed")
    }
  }

  processPendingActions() {
    while (this.pendingActions.length > 0) {
      const { action, resolve, reject } = this.pendingActions.shift()
      this.executeRecaptcha(action).then(resolve).catch(reject)
    }
  }
}

const recaptchaEnterprise = new RecaptchaEnterprise()

export const initLazyLoadingRecaptcha = () => {
  const triggerEvents = ["mousedown", "touchstart", "keydown", "scroll"]
  let recaptchaLoadScriptAdded = false

  const loadOnInteraction = () => {
    if (recaptchaLoadScriptAdded) return
    recaptchaLoadScriptAdded = true

    // Remove event listeners to prevent multiple loads
    triggerEvents.forEach((event) => {
      document.removeEventListener(event, loadOnInteraction)
    })

    requestIdleCallback(
      () => {
        recaptchaEnterprise.initialize()
      },
      { timeout: 5000 },
    )
  }

  triggerEvents.forEach((event) => {
    document.addEventListener(event, loadOnInteraction, { passive: true })
  })

  setTimeout(() => {
    if (!recaptchaLoadScriptAdded) {
      loadOnInteraction()
    }
  }, 10000)
}

export const RECAPTCHA_ACTIONS = {
  LOGIN: 'LOGIN',
  REVIEW: 'REVIEW',
  RESERVATION: 'RESERVATION'
}
export default recaptchaEnterprise
